import { gql } from '@apollo/client';

export interface ILibraryPriceLevel {
  name: string;
  id: string;
}

export const LibraryPriceLevelFragment = gql`
  fragment LibraryPriceLevel on LibraryPriceLevel {
    name
    sys {
      id
    }
  }
`;
